
<div class="form-group form-check former-input" :class="[ {'former-has-value': model[field.key], 'has-error': hasError}, field.className]">
  <input :id="'cb_'+this.field.key+'_'+_uid" v-model="model[field.key]" type="checkbox" class="form-check-input" @blur="onBlur" @focus="onFocus" @click="onClick" @change="onChange" @keyup="onKeyup" @keydown="onKeydown">
  <label v-if="to.label" class="form-check-label" :for="'cb_'+this.field.key+'_'+_uid">{{to.label}}</label>
  <small v-if="to.help"><br>{{ to.help }}</small>
  <error-display :form="form" :field="field.key"></error-display>
</div>
